import { render, staticRenderFns } from "./BookingUploadVideo.vue?vue&type=template&id=027ccc6e"
import script from "./BookingUploadVideo.vue?vue&type=script&lang=js"
export * from "./BookingUploadVideo.vue?vue&type=script&lang=js"
import style0 from "./BookingUploadVideo.vue?vue&type=style&index=0&id=027ccc6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports